import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { client } from "../../sdk/client/client";

const ProcessingRepayments = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleProcessRepayments = async () => {
      console.log("Retrieving repayments from local storage...");

      let data = location.state?.response?.data;

      if (!data) {
        const storedData = localStorage.getItem("bulkRepaymentData");
        if (storedData) {
          data = JSON.parse(storedData);
        }
      }

      console.log("Retrieved Repayments Data:", data);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.error("Invalid data: A non-empty array is required", data);
        return;
      }

      try {
        const startTime = Date.now();

        const response = await client.post(
          "/api/v1/loan/process-deductions",
          data
        );

        if (response.status === 200 || response.status === 201) {
          const updatedRecords = response.data?.data?.data || [];

          const summaryCounts = {
            flashLoan: updatedRecords.filter(
              (loan) => loan.type === "FlashLoan"
            ).length,
            emergencyLoan: updatedRecords.filter(
              (loan) => loan.type === "EmergencyLoan"
            ).length,
            savings: updatedRecords.filter((loan) => loan.type === "Savings")
              .length,
            shares: updatedRecords.filter((loan) => loan.type === "Shares")
              .length,
            normalLoan: updatedRecords.filter(
              (loan) => loan.type === "NormalLoan"
            ).length,
            jijengeLoan: updatedRecords.filter(
              (loan) => loan.type === "JijengeLoan"
            ).length,
            developmentLoan: updatedRecords.filter(
              (loan) => loan.type === "DevelopmentLoan"
            ).length,
          };

          console.log("Summary of Updated Accounts:", summaryCounts);
          const elapsedTime = Date.now() - startTime;
          const delay = Math.max(4000 - elapsedTime, 0);

          setTimeout(() => {
            navigate("/dashboard/bulk-repayment/summary", {
              state: { summaryCounts },
            });
          }, delay);
        } else {
          console.error("Unexpected response status:", response.status);
        }
      } catch (error) {
        console.error(
          "Error processing deductions:",
          error.response?.data || error
        );
      }
    };

    handleProcessRepayments();
  }, [navigate, location]);

  return (
    <div className="flex flex-col h-screen bg-white p-6">
      <div className="self-start text-left">
        <h1 className="text-xl font-bold text-green-900">Bulk Repayments</h1>
        <p className="text-lg font-bold mt-2">
          Processing your file and updating records...{" "}
          <span className="italic">Please wait.</span>
        </p>
        <p className="text-gray-600 mt-1">
          Review the records before finalizing the update to ensure accuracy.
        </p>
      </div>
      <div className="flex-grow flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 24 24"
        >
          <circle cx="18" cy="12" r="0" fill="#000">
            <animate
              attributeName="r"
              begin=".67"
              calcMode="spline"
              dur="1.5s"
              keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
              repeatCount="indefinite"
              values="0;2;0;0"
            />
          </circle>
          <circle cx="12" cy="12" r="0" fill="#000">
            <animate
              attributeName="r"
              begin=".33"
              calcMode="spline"
              dur="1.5s"
              keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
              repeatCount="indefinite"
              values="0;2;0;0"
            />
          </circle>
          <circle cx="6" cy="12" r="0" fill="#000">
            <animate
              attributeName="r"
              begin="0"
              calcMode="spline"
              dur="1.5s"
              keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
              repeatCount="indefinite"
              values="0;2;0;0"
            />
          </circle>
        </svg>
      </div>
    </div>
  );
};

export default ProcessingRepayments;
